import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { getFilterParams } from '@/metrics/helpers/helpers'
import metricsServices from '@/metrics/services/services'

import { transformResponseReasonSummary } from './transformers'

const useReasonSummary = ({ reasonKey, subReasonId, filters, ordering, returnPortalId }) => {
  const [hasError, setHasError] = useState(false)

  const { data, loading, fetchDataCancellable } = useFetch(metricsServices.getReasonSummary, {
    doInitialRequest: false,
    transformResponse: transformResponseReasonSummary,
  })

  const handleError = () => setHasError(true)

  const refetchWhenArgsChange = () => {
    if (!ordering) return

    setHasError(false)
    fetchDataCancellable(
      {
        returnPortalId,
        reasonId: reasonKey,
        params: getFilterParams({ ...filters, ordering, subReasonId }),
      },
      null,
      handleError
    )
  }

  useEffect(refetchWhenArgsChange, [fetchDataCancellable, filters, ordering, reasonKey, returnPortalId, subReasonId])

  return { reasonSummary: data, loadingReasonSummary: loading, reasonSummaryError: hasError }
}

export default useReasonSummary
